/**
 * @module Components.Inputs
 *
 */
import React from "react";
import { FormattedMessage } from "react-intl";
import CheckBox, { PropsDef } from "app/components/inputs/CheckBox/Base";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export default function AgeConsent(props: PropsDef) {
  const { t } = useTranslation();

  const consentText = (
    <div className={styles.checkbox_label}>
      <FormattedMessage
        id="app.form-label.age-consent"
        defaultMessage={t("I'm older than 13")}
      />
      <div>
        <FormattedMessage
          id="app.form-label.age-disclaimer"
          defaultMessage={t(
            "If not, billing information is needed to confirm parental consent.",
          )}
        />
      </div>
    </div>
  );

  return <CheckBox {...props} name="ageConsent" label={consentText} />;
}
